<template>
    <div>
          <b-overlay
          :show="loading"
          rounded="sm"
        >
        <b-modal id="modal-stranger" centered size="lg" :hide-footer="true" ref="modal-stranger" :title="stranger.in_time">
            <b-img :src="stranger.image" style="width:100%" />
        </b-modal>
        
        <b-row>
            <b-col md="2" sm="12">
                <b-card>
                    <b-button-group style="width:100%;">
                        <!-- <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary" @click="change_view('list')">
                            <font-awesome-icon icon="fa-solid fa-list" />
                        </b-button> -->
                        <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary" @click="change_view('grid')">
                            <font-awesome-icon icon="fa-solid fa-grip" />
                        </b-button>
                    </b-button-group>
                    <hr />
                   
                    
                    <b-form-group label="Date" label-for="Date">
                        <flat-pickr v-model="rangeDate" class="form-control mb-1 mr-1" :config="{ mode: 'single'}" />
                    </b-form-group>
                    <b-form-group label="From " label-for="Start ">
                        <b-form-input id="from" v-mask="'##:##'" v-model="time.from" trim />
                    </b-form-group>
                    <b-form-group label="To " label-for="To">
                        <b-form-input id="to" v-mask="'##:##'" v-model="time.to" trim />
                    </b-form-group>
                    <b-button variant="primary" class="my-2" @click="get_data()" block>
                        <span class="text-nowrap">Submit</span>
                    </b-button>
                    <hr class="my-2" />

                </b-card>
            </b-col>
            <b-col md="10" sm="12">
    
    <div v-if="view == 'grid'">
      <b-row>
        <b-col
          v-for="item in items"
          :key="item.id"
          md="3"
          lg="2"
          class="p-0 mx-1"
        >
          <b-card style="padding:0rem !important;" class="p-0">
              <b-img-lazy rounded thumbnail :src="'data:image/jpeg;base64,'+item.image" fluid class="w-100" onerror="this.src='//cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_640.png'"  />
              <b-badge class="d-block mt-75" variant="light-dark" style="font-size:13px;">{{ item.created_at }}</b-badge>
              <b-button block size="sm" class="mt-50" @click="delete_stranger(item.id)" variant="outline-danger">{{ $t('Delete') }}</b-button>
              <b-badge class="d-block mt-75" variant="light-dark" style="font-size:13px;" v-if="item.score">Score : {{ item.score }}</b-badge>
              <b-badge class="d-block mt-75" variant="light-dark" style="font-size:13px;" v-if="item.target_code">{{ item.target_code }}</b-badge>

          </b-card>
        </b-col>
      </b-row>
    </div>
  </b-card>
    </b-col>
    </b-row>
    </b-overlay>
  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'

import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import moment from 'moment'
import {
    BMedia,
    BMediaAside,
    BCardHeader,
    BOverlay,
    BCardTitle,
    BMediaBody,
    BCard,
    BImg,
    BImgLazy,
    BTable,
    BTime,
    BAvatar,
    BButtonGroup,
    BCardBody,
    BLink,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BInputGroupPrepend,
    BModal,
    VBModal
} from 'bootstrap-vue'
export default {
    components: {
        moment,
        BImg,
        BCard,
        BCardHeader,
        BCardTitle,
        flatPickr,
        BTable,
        BModal,
        VBModal,
        BAvatar,
        BLink,
        BBadge,
        BButtonGroup,
        BRow,
        BCol,
        BMedia,
        BImg,
        BImgLazy,
        BMediaAside,
        BMediaBody,
        BFormGroup,
        BFormSelect,
        BOverlay,
        BPagination,
        BInputGroup,
        BFormInput,
        BInputGroupAppend,
        BInputGroupPrepend,
        BButton,
        BPagination,
        BCardCode,
        BTable,
        BButton,
        BTime,
        BFormGroup,
        BAvatar,
        BCardBody,
        BBadge,
        vSelect,
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            loading: true,
            selected_status: 'ALL',
            rangeDate: null,
            user_id: 'all',
            view: 'grid',
            stat: {
                records: 0,
                members: 0
            },
            staffOptions: [],
            target_type: 'ALL',
            headerTitle: ['#', 'STAFF', 'CLIENT', 'START AT', 'END AT', 'SALARY', 'ATTEND', 'REMARKS'],
            headerVal: ['id', 'display_name', 'member_name', 'start', 'end', 'salary', 'attend', 'remarks'],
            genderOptions: [
                { label: 'Male', value: 'M' },
                { label: 'Female', value: 'F' },
            ],
            planOptions: [
                { label: 'Basic', value: 'basic' },
                { label: 'Company', value: 'company' },
                { label: 'Enterprise', value: 'enterprise' },
                { label: 'Team', value: 'team' },
            ],
            targetOptions: [
                { label: 'ALL', value: 'ALL' },
                { label: 'STAFF', value: 'STAFF' },
                { label: 'MEMBER', value: 'MEMBER' }
            ],
            statusOptions: [
                { label: 'GRANT', value: 'GRANT' },
                { label: 'DENY', value: 'DENY' },
                { label: 'WARNING', value: 'WARNING' },
            ],
            centerOptions: [],
            salary: 0,
            isAddNewMemberSidebarActive: false,
            stranger: {
                in_time: null
            },
            searchString: null,
            time: {
                from: moment().subtract(12, 'hours').format('HH:mm'),
                to: moment().add(2, 'minutes').format('HH:mm'),
            },
            stranger_image_src: null,
            perPage: 10,
            startRow: 1,
            endRow: 10,
            pageOptions: [10, 15, 20],
            totalRows: 1,
            currentPage: 1,
            fields: [
                { key: 'center_name', label: 'Center' },
                { key: 'access_device', label: 'Device' },
                { key: 'target_type', label: 'Type' },
                { key: 'target_name', label: 'Name' },
                { key: 'plan_expire', label: 'Expire' },
                { key: 'in_time', label: 'IN' },
                { key: 'out_time', label: 'OUT' },
                { key: 'status_number', label: 'STATUS' }
            ],
            /* eslint-disable global-require */
            items: [],
            /* eslint-disable global-require */
            status: [{
                    1: 'Grant',
                    2: 'Deny',
                    3: 'Warning'
                },
                {
                    1: 'light-success',
                    2: 'light-danger',
                    3: 'light-warning'
                }
            ],
            selectMode: 'single',
            selected: [],
        }
    },
    watch: {
        user_id: {
            handler(newValue, oldValue) {
                this.get_data()
            },
        },
        rangeDate: {
            handler(newValue, oldValue) {
                this.get_data()
            },
        },
        selected_status: {
            handler(newValue, oldValue) {
                this.get_data()
            },
        },
        currentPage: {
            handler(newValue, oldValue) {
                this.get_data()
            },
        },
        searchString: {
            handler(newValue, oldValue) {
                // console.log("search")
                this.searchString = newValue.toUpperCase()
                this.handleSearch()
            },
        },
        perPage: {
            handler(newValue, oldValue) {
                if (newValue < 9) {
                    this.perPage = 10
                }
                // console.log("search")
                this.handleSearch()
            },
        },
    },
    created() {
        this.get_data()
    },
    methods: {
      delete_stranger(id) {
        this.$http.post(process.env.VUE_APP_API_BASE+'/stranger/' + id + '/delete/')
          .then(res => {
            this.get_data()
          })
      },
          link(target) {
            switch (target.target_type) {
              case "MEMBER":
                this.$router.push(`/apps/member/edit/${target.taget_token}/`)
                break;
              case "STAFF":
                this.$router.push(`/apps/staff/edit/${target.taget_token}/`)
            }
          },
        change_view(view_type) {
            this.view = view_type
        },
        exportToExcel() {
            //  console.log(this.rangeDate)
            import ('@/@core/Export2Excel').then(excel => {
                const list = this.items
                const data = this.formatJson(this.headerVal, list)
                excel.export_json_to_excel({
                    header: this.headerTitle,
                    data,
                    filename: 'pt-report',
                    autoWidth: true,
                    stringifyLongNum: true,
                    bookType: 'xlsx'
                })
                this.clearFields()
            })
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v =>
                filterVal.map(j => {
                    // Add col name which needs to be translated
                    if (j === 'salary') {
                        return parseFloat(v[j])
                    } else {
                        return j + v[j]
                    }

                    return v[j]
                })
            )
        },
        get_data() {
            var splitted = []
            this.loading = true
            if (this.rangeDate === null) {
                this.rangeDate = moment().format('YYYY-MM-DD')
            } else {
                //  splitted = this.rangeDate.split(" to ");
            }
            this.$http.get(process.env.VUE_APP_API_BASE + `/report/stranger/`+this.$store.getters['center/currentCenterId'] + `/?date=` + this.rangeDate + `&from=` + this.time.from + `&to=` + this.time.to)
                .then(res => {
                    this.loading = false
                    this.items = res.data.records
                   this.totalRows = this.items.length
                  this.time.to = moment().add(2, 'minutes').format('HH:mm')
                })
        },
        stranger_image(image) {
            this.stranger = image[0]
            console.log(this.stranger)
            if (image[0].target_type != 'STRANGER') { return }
            this.stranger.image = 'data:image/jpg;base64,' + image[0].image

            this.$refs['modal-stranger'].show()
        },
        get_center_data() {
            this.$http.get(process.env.VUE_APP_API_BASE + '/centers/')
                .then(res => {
                    this.centerOptions = res.data.centers
                })
        },
        handleChangePage() {

            //  this.get_data()
        },
        onRowSelected(items) {
            this.selected = items[0]
            console.log(items)
            if (items[0].is_pdf == 'Y') {
                //this.iframe_src = '//www.cloudfit.pro/pdf/INVOICE_'+items[0].code+'.pdf'
                //console.log(this.iframe_src)

            } else {
                //this.iframe_src = process.env.VUE_APP_API_BASE+'/invoice.php?print=n&code='+items[0].id
            }
            //this.transaction_id = items[0].transaction_id
            //  this.$refs['my-modal'].show()
        },

        selectAllRows() {
            this.$refs.selectableTable.selectAllRows()
        },
        clearSelected() {
            this.$refs.selectableTable.clearSelected()
        },
        selectThirdRow() {
            // Rows are indexed from 0, so the third row is index 2
            this.$refs.selectableTable.selectRow(2)
        },
        unselectThirdRow() {
            // Rows are indexed from 0, so the third row is index 2
            this.$refs.selectableTable.unselectRow(2)
        },

        handleSearch() {
            // let _print = `The user searched for: ${searching}\n`
            // this.$refs.pre.appendChild(document.createTextNode(_print))
            // this.searchString = searching
            // this.currentx = 1
            // this.get_data()
            this.searchTimeOut()
        },
        searchTimeOut() {
            if (this.timer) {
                clearTimeout(this.timer)
                this.timer = null
            }
            this.timer = setTimeout(() => {
                // your code
                this.currentPage = 1
                this.get_data()
            }, 500)
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>

<style lang="scss">
  .card-body {
    padding: 0.75rem !important;
  }
.b-table-selectable {
    .feather {
        font-size: 1.3rem;
    }
}
</style>
